import React from 'react'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import Button from '../../../../../components/Button'
import FormRow from '../../../../../components/FormFields/FormRow'
import TextField from '../../../../../components/FormFields/TextField'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'
import ActivityField from '../../../../Activities/ActivitiesField'

import { getApplyToStepPath } from '../../../../MainRoutes/utils'
import { stepStatuses } from '../../../constants'
import { StatusSteps } from '../../StatusSteps'

const makeDownshiftHandleChange = ({ setFieldValue, setFieldTouched }) => name => value => {
  setFieldTouched(name)
  setFieldValue(name, value)
}

function ActivityForm({
  values,
  status = {},
  errors,
  touched,
  isSubmitting,
  setFieldTouched,
  setFieldValue,
  handleChange,
  handleBlur,
  handleSubmit,
  application
}) {
  const handleDownshiftChange = makeDownshiftHandleChange({ setFieldValue, setFieldTouched })
  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <ActivityField
          name='sector'
          label='Sector de actividad'
          value={values.sector}
          onChange={handleDownshiftChange('sector')}
          onBlur={handleBlur}
          error={showFieldError('sector', { errors, touched })}
          help={renderValidation('sector', { errors, touched })}
          full
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='doing'
          value={values.doing}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('doing', { errors, touched })}
          help={renderValidation('doing', { errors, touched })}
          label='¿A qué se dedica tu organización?'
          tip='Cuéntanos con más detalle la misión o actividad a la que se dedica  tu organización'
          forceTip
          full
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='main_products'
          value={values.main_products}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('main_products', { errors, touched })}
          help={renderValidation('main_products', { errors, touched })}
          label='¿Cuáles son tus principales productos o servicios?'
          full
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='targeting'
          value={values.targeting}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('targeting', { errors, touched })}
          help={renderValidation('targeting', { errors, touched })}
          label='¿A quién van dirigidos?'
          full
        />
      </FormRow>
      {status.error && (
        <FormError>
          <FormattedMessage {...getExceptionMessage(status.error)} />
        </FormError>
      )}
      <FormActions>
        <Button type='submit' disabled={isSubmitting}>Continuar</Button>
        <Link to={getApplyToStepPath(stepStatuses.DATA, application)}>Volver</Link>
      </FormActions>
      <StatusSteps />
    </form>
  )
}

export default ActivityForm
